import { addScript } from "../../bootstrap-utils";

let scriptUrl: string | undefined;
let loadPromise: Promise<void> | undefined;

export function setBetbyScriptUrl(url: string): void {
  scriptUrl = url;
}

export function getBetbyScriptUrl(): string | undefined {
  return scriptUrl;
}

/**
 * Loads the Betby bt-renderer script on demand.
 * Idempotent — the script is only injected once regardless of how many times this is called.
 * If no URL has been registered (e.g. the operator loads bt-renderer via another mechanism),
 * this is a no-op and the caller's waitForBTRenderer polling will find it already available.
 */
export function loadBetbyScript(): Promise<void> {
  if (loadPromise) {
    return loadPromise;
  }
  if (!scriptUrl) {
    return Promise.resolve();
  }
  loadPromise = addScript(scriptUrl).catch((err) => {
    loadPromise = undefined;
    throw err;
  });
  return loadPromise;
}

/** Resets module state — for use in tests only. */
export function _resetBetbyScriptLoader(): void {
  scriptUrl = undefined;
  loadPromise = undefined;
}
